import axios from '@/service/request';
import type { R, BuyerOperationTypeEnum } from './types';


export interface CaptchaCheckRequest {
  /** 手机国内号码或邮箱 */
  account: string;
  /** 手机国际区号（如 +86），邮箱校验不传 */
  countryRegionCode?: string;
  captcha: string;
  operationType: BuyerOperationTypeEnum.REGISTER;
}


/**
 * 三方免登(一次性ticket获取)
 */
export const apiCaptchaCheck = (data: CaptchaCheckRequest): Promise<R<boolean>> => {
  return axios.post('/buyer/captcha/check', data);
};

